'use client';
var classes = {"root":"m_bcb3f3c2"};

export { classes as default };
//# sourceMappingURL=Mark.module.css.mjs.map
